import { render, staticRenderFns } from "./TermsServicePopup.vue?vue&type=template&id=fc6472aa"
import script from "./TermsServicePopup.vue?vue&type=script&lang=js"
export * from "./TermsServicePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports